import Contact from "../views/contact"

const ContactUs = () => {
  return <Contact />
}
export default ContactUs
